import React, {createContext, useState} from 'react';

interface Props {
    children: React.ReactNode
}

interface MenuSearchContextType {
    search: string;
    setSearch: (search: string) => void;
    showSearchBar: boolean;
    setShowSearchBar: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MenuSearchContext = createContext<MenuSearchContextType>({
    search: "",
    showSearchBar: false,
    setShowSearchBar: () => {
    },
    setSearch: () => {
    }
});

const MenuSearchProvider = ({children}: Props) => {
    const [search, setSearch] = useState("");
    const [showSearchBar, setShowSearchBar] = useState(false);

    return (
        <MenuSearchContext.Provider value={{
            setSearch,
            search,
            setShowSearchBar,
            showSearchBar,
        }}>
            {children}
        </MenuSearchContext.Provider>
    )
}

export default MenuSearchProvider;